import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const READ_ONLY_SESSION_KEY = 'setvi-outlook-read-only';

/**
 * Whether this Outlook dialog was opened in read-only mode (the add-in over a
 * received email, where nothing can be inserted). The add-in passes
 * `?readOnly=true` on the first page only, so the flag is remembered for the
 * dialog window: it must survive navigation inside the dialog (list → details,
 * catalog → product), where the query string is gone. Every Office dialog is
 * its own window with its own sessionStorage, so a compose dialog never
 * inherits it.
 */
export const useOutlookReadOnly = () => {
  const [searchParams] = useSearchParams();
  const fromQuery = searchParams.get('readOnly') === 'true';

  useEffect(() => {
    if (fromQuery) sessionStorage.setItem(READ_ONLY_SESSION_KEY, 'true');
  }, [fromQuery]);

  // Check the query too — the flag is only written in an effect, so it isn't
  // set yet on the first render of the dialog's first page.
  return fromQuery || sessionStorage.getItem(READ_ONLY_SESSION_KEY) === 'true';
};
